"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgFilters(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M16 12a2 2 0 011.732 1H20v2l-2.268.001a2 2 0 01-3.464 0L4 15v-2h10.268A2 2 0 0116 12zM8 6a2 2 0 011.732 1H20v2l-10.268.001a2 2 0 01-3.464 0L4 9V7h2.268A2 2 0 018 6zm4-6a2 2 0 011.732 1H20v2l-6.268.001a2 2 0 01-3.464 0L4 3V1h6.268A2 2 0 0112 0z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Filters')(SvgFilters);
//# sourceMappingURL=Filters.js.map